// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\BerthAssignmentDetails\BerthAssignmentDetailsResponse.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BerthReservation, BerthReservationData, BerthReservationOptions } from 'data/models/BerthReservation';
import { PortCallRights } from 'server/enums/Rights';

// BerthAssignmentDetailsResponseData is the class that BerthAssignmentDetailsResponse serializes to/from
export interface BerthAssignmentDetailsResponseData {
    Id : number;
	
    BerthReservation : BerthReservationData | null;
	
    PCRights : PortCallRights;
}

// BerthAssignmentDetailsResponseOptions is the class which may be passed to the BerthAssignmentDetailsResponse constructor to define optional initial data values
export interface BerthAssignmentDetailsResponseOptions {
    Id : number;
	
    BerthReservation? : BerthReservationOptions | null;
	
    PCRights? : PortCallRights;
}

export class BerthAssignmentDetailsResponse {
    public Id : DataSignal<number>;
	
    public BerthReservation : DataSignal<BerthReservation | null>;
	
    public PCRights : DataSignal<PortCallRights>;

    constructor();
    constructor(data : BerthAssignmentDetailsResponseOptions);
    constructor(data: BerthAssignmentDetailsResponseOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.BerthReservation = S.value<BerthReservation | null>(null);
	    
        this.PCRights = jsonableObservable(S.value<PortCallRights>(data && data.PCRights !== undefined ? data.PCRights : 0));
    }

    static key(obj : BerthAssignmentDetailsResponse) {
        return obj.Id();
    }
    
    static dataKey(obj : BerthAssignmentDetailsResponseOptions) {
        return obj.Id;
    }

    static update(obj : BerthAssignmentDetailsResponse, data : BerthAssignmentDetailsResponseOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.PCRights !== undefined) obj.PCRights(data.PCRights);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BerthAssignmentDetailsResponse.ts